import { IBook } from './types';
import { getBookTextInputData } from './inputs/text/utils';
import { getBookRadioInputData, getBookRadioInputOptionData } from './inputs/radio/utils';
import { getBookPriceData } from './prices/utils';
import { getBookSelectInputData, getBookSelectInputOptionData } from './inputs/select/utils';
import { months, days, getFilledNumbersArray } from 'src/app/shared/timepicker-select/timepicker-select.data';
import {
  BOOK_ALIAS_WHERE_IS_BIRTHDAY_CAKE,
  INPUT_NAME_KIDS_NAME,
  INPUT_NAME_KIDS_BIRTHDAY_MONTH,
  INPUT_NAME_KIDS_BIRTHDAY_DAY,
  INPUT_NAME_AGE_TO_BE,
  INPUT_VALUE_GENDER_BOY,
  INPUT_VALUE_GENDER_GIRL,
  INPUT_NAME_GENDER,
  BOOK_PRICE_WHERE_IS_BIRTHDAY_CAKE,
  BOOK_PRICE_WHERE_IS_BIRTHDAY_CAKE_HARD_COVER,
  INPUT_NAME_GLASSES,
  INPUT_NAME_HAIR_STYLE,
  INPUT_VALUE_TIME_OF_THE_YEAR_SPRING,
  INPUT_VALUE_TIME_OF_THE_YEAR_SUMMER,
  INPUT_VALUE_TIME_OF_THE_YEAR_AUTUMN,
  INPUT_VALUE_TIME_OF_THE_YEAR_WINTER,
  INPUT_NAME_SEASON,
} from '@shared/book/constants';
import { EBookBannerTextColor, EBookBannerTextSize } from './banner/types';
import { EBookDescriptionTextItemType } from './desicription/types';
import StaryDream from './StaryDream';
import { getBookNameValidatorList } from 'src/app/validators';
import { GET_BOOK_NAME_ERROR } from 'src/app/validators.constants';
import { getBookRadioImageInputData, getBookRadioImageInputOptionData } from './inputs/radioImage/utils';
import { getBookCheckboxInputData } from './inputs/checkbox/utils';
import { bookInputShowWhen } from './inputs/utils';
import { GENDER_TO_HAIR_STYLE_WIBC_MAP } from '@shared/book/maps';
import { TGender } from '@shared/book/interfaces';
import { TBookRadioInputOption } from './inputs/radio/types';

export const WhereIsBirthdayCakeInputsGender = getBookRadioInputData({
  label: '性別',
  options: [
    getBookRadioInputOptionData({
      label: 'Boy',
      value: INPUT_VALUE_GENDER_BOY,
    }),
    getBookRadioInputOptionData({
      label: 'Girl',
      value: INPUT_VALUE_GENDER_GIRL,
    }),
  ] as TBookRadioInputOption[],
  // value: '',
  name: INPUT_NAME_GENDER,
} as const);

export const WhereIsBirthdayCakeInputsKidsName = getBookTextInputData({
  label: 'Kid’s name',
  placeholder: 'ひらがな6文字まで',
  // value: '',
  name: INPUT_NAME_KIDS_NAME,
  validator: getBookNameValidatorList(6, 2),
  error: GET_BOOK_NAME_ERROR(6),
} as const);

export const WhereIsBirthdayCakeInputsKidsBirthdayMonth = getBookSelectInputData({
  label: 'Kid’s birthday',
  placeholder: 'mm',
  options: months.map(
    (month) => getBookSelectInputOptionData({ label: month, value: month }),
  ),
  // value: '',
  name: INPUT_NAME_KIDS_BIRTHDAY_MONTH,
} as const);

export const WhereIsBirthdayCakeInputsKidsBirthdayDay = getBookSelectInputData({
  label: '',
  placeholder: 'dd',
  options: days.map(
    (day) => getBookSelectInputOptionData({ label: day, value: day }),
  ),
  // value: '',
  name: INPUT_NAME_KIDS_BIRTHDAY_DAY,
} as const);

export const WhereIsBirthdayCakeInputsAgeToBe = getBookSelectInputData({
  label: 'もうすぐ',
  placeholder: '1~10yo',
  options: getFilledNumbersArray(1, 10, 1).map(
    (year) => getBookSelectInputOptionData({ label: year, value: year }),
  ),
  // value: '',
  name: INPUT_NAME_AGE_TO_BE,
} as const);

export const WhereIsBirthdayCakeInputsHairStyleBoy = getBookRadioImageInputData({
  label: '主人公にそっくりな子を選びましょう',
  options: GENDER_TO_HAIR_STYLE_WIBC_MAP[INPUT_VALUE_GENDER_BOY].map(
    (value, index) => getBookRadioImageInputOptionData({
      imgSrc: `/assets/images/wibc-hair-styles/boy/${index + 1}.png`,
      value,
    })
  ),
  // value: '',
  name: INPUT_NAME_HAIR_STYLE,
} as const);

export const WhereIsBirthdayCakeInputsHairStyleGirl = getBookRadioImageInputData({
  label: '主人公にそっくりな子を選びましょう',
  options: GENDER_TO_HAIR_STYLE_WIBC_MAP[INPUT_VALUE_GENDER_GIRL].map(
    (value, index) => getBookRadioImageInputOptionData({
      imgSrc: `/assets/images/wibc-hair-styles/girl/${index + 1}.png`,
      value,
    })
  ),
  // value: '',
  name: INPUT_NAME_HAIR_STYLE,
} as const);

export const WhereIsBirthdayCakeInputsGlasses = getBookCheckboxInputData({
  label: 'メガネをかける',
  // value: false,
  name: INPUT_NAME_GLASSES,
  value: false,
} as const);

export const WhereIsBirthdayCakeInputsSeason = getBookRadioInputData({
  label: '',
  placeholder: '',
  options: [
    getBookRadioInputOptionData({
      label: INPUT_VALUE_TIME_OF_THE_YEAR_SPRING,
      imgSrc: '/assets/images/season-step/b5_spring.png',
      imgExpandTopPx: 20,
      imgExpandRightPx: 33,
      imgExpandBottomPx: 4,
      value: INPUT_VALUE_TIME_OF_THE_YEAR_SPRING,
    }),
    getBookRadioInputOptionData({
      label: INPUT_VALUE_TIME_OF_THE_YEAR_SUMMER,
      imgSrc: '/assets/images/season-step/b5_summer.png',
      imgExpandTopPx: 20,
      imgExpandRightPx: 33,
      imgExpandBottomPx: 4,
      value: INPUT_VALUE_TIME_OF_THE_YEAR_SUMMER,
    }),
    getBookRadioInputOptionData({
      label: INPUT_VALUE_TIME_OF_THE_YEAR_AUTUMN,
      imgSrc: '/assets/images/season-step/b5_autumn.png',
      imgExpandTopPx: 20,
      imgExpandRightPx: 33,
      imgExpandBottomPx: 4,
      value: INPUT_VALUE_TIME_OF_THE_YEAR_AUTUMN,
    }),
    getBookRadioInputOptionData({
      label: INPUT_VALUE_TIME_OF_THE_YEAR_WINTER,
      imgSrc: '/assets/images/season-step/b5_winter.png',
      imgExpandTopPx: 20,
      imgExpandRightPx: 33,
      imgExpandBottomPx: 4,
      value: INPUT_VALUE_TIME_OF_THE_YEAR_WINTER,
    }),
  ],
  // value: '',
  name: INPUT_NAME_SEASON,
});

const WhereIsBirthdayCake: IBook = {
  caption: 'Where is the birthday cake?',
  summary: ['1月、2月・・、お友達が無くしたものは、１年のどこにある？見つけたものを合わせると、サプライズが！'],
  alias: BOOK_ALIAS_WHERE_IS_BIRTHDAY_CAKE,
  prices: [
    ['soft', getBookPriceData(BOOK_PRICE_WHERE_IS_BIRTHDAY_CAKE)],
    ['hard', getBookPriceData(BOOK_PRICE_WHERE_IS_BIRTHDAY_CAKE_HARD_COVER)],
  ],
  photos: [
    '/assets/images/book4-carousel01.jpeg',
    '/assets/images/book5-carousel02.jpg',
    '/assets/images/book4-carousel03.jpeg',
    '/assets/images/book4-carousel04.jpeg',
  ],
  menuPhoto: '/assets/images/book5-sample.png',
  previewPhoto: '/assets/images/book5-sample.png',
  properties: {
    purpose: ['Birthday'],
    age: {
      start: 3,
      end: 10,
    },
  },
  notice: {
    caption: 'book.wibc.notice',
    description: 'book.wibc.description',
    points: [
      {
        imgSrc: '/assets/images/starry-dream-notice-point-1.png',
        caption: 'book.wibc.notice.point.1',
      },
      {
        imgSrc: '/assets/images/birthday-notice-point-2.png',
        caption: 'book.wibc.notice.point.2',
      },
    ],
  },
  points: [
    {
      caption: 'どんなカスタマイズができるの？',
      description: '主人公の絵柄を選べ、誕生日や名前によって探すものが変わります。見つけたものを合わせると、その子だけのバースデーケーキが！写真も入れることができます。',
    },
    {
      caption: '絵本のストーリーは？',
      description: '『大事なものを置いてきてしまったんだ！』と、季節のキャラクターが言います。主人公はそれをを探しに、一年の大冒険にでかけます！最後にはとっておきのサプライズが、主人公を待っています。',
    },
    {
      caption: 'ページ数や絵本の大きさは？',
      description: '全34ページ、本文の大きさは幅21cm 高さ29.7cmのA4縦。',
    },
  ],
  inputs: [
    WhereIsBirthdayCakeInputsKidsName,
    WhereIsBirthdayCakeInputsKidsBirthdayMonth,
    WhereIsBirthdayCakeInputsKidsBirthdayDay,
    WhereIsBirthdayCakeInputsAgeToBe,
    WhereIsBirthdayCakeInputsGender,
    bookInputShowWhen(
      WhereIsBirthdayCakeInputsHairStyleBoy,
      WhereIsBirthdayCakeInputsGender,
      (gender: TGender) => gender === INPUT_VALUE_GENDER_BOY,
    ),
    bookInputShowWhen(
      WhereIsBirthdayCakeInputsHairStyleGirl,
      WhereIsBirthdayCakeInputsGender,
      (gender: TGender) => gender === INPUT_VALUE_GENDER_GIRL,
    ),
    bookInputShowWhen(
      WhereIsBirthdayCakeInputsGlasses,
      WhereIsBirthdayCakeInputsGender,
    ),
  ],
  banner: {
    imgSrc: '/assets/images/book4-banner-desktop.jpeg',
    imgSrcLtMd: '/assets/images/book4-banner-mobile.jpeg',
    text: '',
    textLtMd: 'いちねんの　だいぼうけんに　しゅっぱつだ！<br>もくてきちは、たんじょうび！',
    textColor: EBookBannerTextColor.dark,
    textSize: EBookBannerTextSize.sm,
  },
  description: [
    {
      imgSrc: '/assets/images/book4-images01.gif',
      text: [
        {
          type: EBookDescriptionTextItemType.caption,
          text: 'さがして！みつけて！365日、毎日が大冒険'
        }, {
          type: EBookDescriptionTextItemType.regular,
          text: 'お友達が無くしたものを探しに、主人公が向かったのは、１月、７月。'
        }, {
          type: EBookDescriptionTextItemType.regular,
          text: 'ここでは何を見つける？ほらほら、あそこ！一年間の大冒険の、はじまりはじまり！',
        },
      ],
    }, {
      imgSrc: '/assets/images/book4-images02.png',
      text: [
        {
          type: EBookDescriptionTextItemType.caption,
          text: '見つけたものを合わせると、バースデーケーキの出来上がり！'
        }, {
          type: EBookDescriptionTextItemType.regular,
          text: 'キャンドル、数字、ひらがな、風船・・。あれあれあれ？これってもしかして、ぼくの・わたしのバースデーケーキ？！主人公へのとっておきのサプライズ！'
        }, {
          type: EBookDescriptionTextItemType.regular,
          text: 'また一年、毎日が大冒険。楽しい毎日を過ごしてね。',
        },
      ],
    },
  ],
  reviews: StaryDream.reviews,
};

export default WhereIsBirthdayCake;
